import { axiosFrontAgent } from "../axiosInstance";


export const OrderController = Object.freeze({
  getOrders: (params: Record<string, unknown>) => axiosFrontAgent.get(`/order`, { params }),
  getOrder: (orderId: string) => axiosFrontAgent.get(`/order/${orderId}`),
  getConfig: (orderId: string) => axiosFrontAgent.get(`/card/order/${orderId}/config`),
  getModel: (orderId: string) => axiosFrontAgent.get(`/card/order/${orderId}/model`),
  updateModel: (orderId: string, components: object) =>
    axiosFrontAgent.post(`/card/order/${orderId}/model`, { components }),
});
